function cleardField(fieldName: string) {
  const field = document.getElementById(fieldName);
  if (field instanceof HTMLInputElement) {
    field.value = '';
  }
}

export default function clearPasswordFields() {
  cleardField('password');
  cleardField('passwordConfirmation');
  cleardField('newPassword');
  cleardField('newPasswordConfirmation');
}
